React = require 'react'
Action = require 'models/action'
Auth = require 'db/auth'
Util = require 'lib/util'
Label = require 'models/label'
t = require('views/internal/recup-with-helpers')()
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'
{ CanonicalDetail } = require 'views/canonical-detail/canonical-detail-components'
{ BoardAndDetailContainer } = require 'common/components/canonical-components/canonical-card'
trackUe = require 'debug/trackUe'
ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
{ getOverflowItems, HIGHLIGHT_TYPE } = require 'views/home/overflow-menu'
TFM = require 'lib/markdown/tfm'

class Highlight extends React.Component
  displayName: 'Highlight'

  constructor: (props) ->
    super props

    @state = {
      isReplying: false
      replyMessage: null
      isWaitingForNetworkResponse: false
      hasReplied: false
      replyAction: null
      replyFailedStatusCode: null
    }

    @trackReplyClick = @trackReplyClick.bind(@)
    @trackSaveClick = @trackSaveClick.bind(@)
    @trackCancelClick = @trackCancelClick.bind(@)

    @onReplyClick = @onReplyClick.bind(@)
    @onSaveClick = @onSaveClick.bind(@)
    @onCancelClick = @onCancelClick.bind(@)
    @onChangeReplyMessage = @onChangeReplyMessage.bind(@)

    @replyActionPromise = null

  componentWillUnmount: ->
    @replyActionPromise?.cancel()

  componentDidMount: ->
    @listenOnCardChange()

  componentDidUpdate: (prevProps) ->
    if prevProps.idAction != @props.idAction
      @props.clearModelListeners()
      @listenOnCardChange()

  listenOnCardChange: =>
    { modelCache, modelListener, idAction } = @props
    card = modelCache.get('Action', idAction)?.getCard()

    modelListener card, 'change', => @forceUpdate()

  formatDefaultReplyMessage: (actionMemberCreator) ->
    if (actionMemberCreator? && !Auth.isMe(actionMemberCreator))
      replyMessage = '@' + actionMemberCreator?.get('username') + ' '
    else
      replyMessage = ''
    replyMessage

  trackReplyClick: ->
    { currentOrgId, modelCache, idAction } = @props
    action = modelCache.get('Action', idAction)

    cardId = action?.getCard().get('id')
    actionId = action.id

    actionVerb = if !@state.isReplying then 'opens' else 'dismisses'
    method = 'by clicking reply on highlights card'
    context = { cardId: cardId, actionId: actionId }

    if currentOrgId
      method = 'by clicking reply on highlights card when filtered by team'
      Object.assign(context, { teamId: currentOrgId })

    trackUe('home', actionVerb, 'comment field', '', '', method, context)

  trackSaveClick: ->
    { currentOrgId, modelCache, idAction } = @props
    action = modelCache.get('Action', idAction)

    cardId = action?.getCard().get('id')
    actionId = action.id

    method = 'by clicking save on highlights card'
    context = { cardId: cardId, actionId: actionId }

    if currentOrgId
      method = 'by clicking save on highlights card when filtered by team'
      Object.assign(context, { teamId: currentOrgId })

    trackUe('home', 'adds', 'comment',  'to card', '',  method, context)

  trackCancelClick: ->
    { currentOrgId, modelCache, idAction } = @props
    action = modelCache.get('Action', idAction)

    cardId = action?.getCard().get('id')
    actionId = action?.id

    method = 'by clicking cancel on highlights card'
    context = { cardId: cardId, actionId: actionId }

    if currentOrgId
      method = 'by clicking cancel on highlights card when filtered by team'
      Object.assign(context, { teamId: currentOrgId })

    trackUe('home', 'dismisses', 'comment field', '', '', method, context)

  trackOnClickCanonicalCard: =>
    { currentOrgId, modelCache, idAction } = @props
    action = modelCache.get('Action', idAction)

    method = 'by clicking card in highlights feed'
    context = { actionId: action?.id, cardId: action?.getCard().get('id') }

    if currentOrgId
      method = 'by clicking card in highlights feed when filtered by team'
      Object.assign(context, { teamId: currentOrgId })

    trackUe('home', 'opens', 'card', '', '', method, context)

  trackOverflowMenuOpens: (cardId) ->
    trackUe('home', 'opens', 'overflow menu', '', '', 'by clicking overflow menu icon on card in highlights feed', { cardId: cardId })

  onReplyClick: ->
    { currentOrgId, modelCache, idAction } = @props
    action = modelCache.get('Action', idAction)
    memberCreator = modelCache.get('Member', action.get('idMemberCreator'))

    @trackReplyClick()

    @setState
      hasReplied: false
      replyAction: null
      replyFailedStatusCode: null
    , =>
      # Delaying the this setState will remount the reply container, skipping
      # the default animation.
      @setState (prevState) ->
        isReplying: !prevState.isReplying
        replyMessage: prevState.replyMessage || @formatDefaultReplyMessage(memberCreator)

  onCancelClick: ->
    @trackCancelClick()
    @setState isReplying: false

  onChangeReplyMessage: (e) ->
    Util.preventDefault(e)
    @setState replyMessage: e.target.value

  onSaveClick: ->
    { currentOrgId, modelCache, idAction } = @props
    action = modelCache.get('Action', idAction)

    @trackSaveClick()

    @setState isWaitingForNetworkResponse: true
    @replyActionPromise?.cancel()
    @replyActionPromise = action.getCard().addComment(@state.replyMessage)
    @replyActionPromise
      .then (action) =>
        @setState {
          replyAction: action
          replyMessage: null
          hasReplied: true
          isReplying: false
          isWaitingForNetworkResponse: false
        }
      .catch (error) =>
        @setState {
          hasReplied: false
          isReplying: true
          isWaitingForNetworkResponse: false
          replyFailedStatusCode: error.status || true
        }

  onDismissClick: =>
    { onDismissClick, idAction } = @props
    onDismissClick idAction

  render: t.renderable ->
    {
      currentOrgId
      idAction
      setFocusedCard
      modelCache
      reactionList
    } = @props

    action = modelCache.get('Action', idAction)
    commentMemberCreator = modelCache.get('Member', action.get('idMemberCreator'))
    memberCreator = Auth.me()

    { isReplying, isWaitingForNetworkResponse, replyMessage, hasReplied, replyAction, replyFailedStatusCode } = @state

    card = action.getCard()
    board = card.getBoard()
    organization = board.getOrganization()
    canReply =
      board?.canComment(Auth.me()) &&
      (action.isAddAttachment() || action.isCommentLike())

    _tfmFormatOpts = {
      card
      board
      siteDomain
      textData: action.get('data').textData
    }

    t.tag BoardAndDetailContainer, { width: 420 }, =>
        t.div { onClick: @trackOnClickCanonicalCard }, ->
          t.tag CanonicalCard, {
            board
            boardClassName: 'canonical-stretch'
            canRemove: false
            card
            cardClassName: 'canonical-stretch'
            labels: card.getLabels().sort(Label.compare)
            list: card.getList()
            members: card.memberList.models
            numNotifications: 0
            organization
            lightBackground: true
          }

        t.div =>
          t.tag CanonicalDetail, {
            actionMemberCreator: commentMemberCreator
            board
            canReply
            cardId: card.get('id')
            collapseComment: action.isCommentLike()
            commentText: TFM.comments.format(action.get('data').text, _tfmFormatOpts).output
            currentOrgId
            date: action.get('date')
            hasReplied
            idAction
            isActionMemberCreatorDeleted: action.get('display')?.entities?.memberCreator?.translationKey == 'action_deleted_account'
            isEdited: !!action.get('data').dateLastEdited
            isReplying
            isWaitingForNetworkResponse
            replyFailedStatusCode
            memberCreator
            overflowMenuItems: getOverflowItems(card, HIGHLIGHT_TYPE, modelCache)
            onCancelClick: @onCancelClick
            onChangeReplyMessage: @onChangeReplyMessage
            onReplyClick: @onReplyClick
            onSaveClick: @onSaveClick
            reactionList
            replyAction
            replyMessage
            onDismissClick: @onDismissClick
            setFocusedCard: => setFocusedCard(card)
            @trackOverflowMenuOpens
          }

module.exports = ModelCacheListener(Highlight)



// WEBPACK FOOTER //
// ./app/scripts/views/home/highlight.coffee